import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }) => ({
  ticketDetailsRecommendationsCheckboxLabel: {
    display: 'table',
    paddingLeft: theme.spacing(1),
    tableLayout: 'fixed',
    whiteSpace: 'pre-wrap',
    wordWrap: 'break-word',
    width: '100%'
  }
}));

export default useStyles;
